module.exports = __webpack_public_path__ + "img/france-cardiovascular-diseases-male.18c043aa.png";